module.exports = __webpack_public_path__ + "static/media/pro-6.8439b5e3.jpg";